<template>
  <div class="fluxity">
    <div>
      <HeaderBar3 :preferred="preferred" :loading="loading" :showSections="true" @setSection_in="setSection_out($event)" :ref="hbref"></HeaderBar3>
    </div>
    <div v-if="section != null && sections.includes(section)">
      <!-- Visualizer -->
      <div v-if="section == 'visualizer' && sections.includes('visualizer')" class="p-2" style="margin-top: 92px;">
        <Visualizer :key="compkeys.visualizer"></Visualizer>
      </div>
      <!-- History -->
      <div v-if="section == 'history' && sections.includes('history')" class="p-2" style="margin-top: 92px;">
        <History :key="compkeys.history"></History>
      </div>
      <!-- Underwork Section-->
      <div v-if="section == 'underwork' && sections.includes('underwork')" class="p-2" style="margin-top: 92px;">
        <div class="fs-1 fw-light" style="margin-top: 18%;" >
          <i class="fa-solid fa-xl fa-cog fa-spin text-warning"></i>
          <div class="fa-fade text-warning">
            Currently under work.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderBar3 from '@/components/HeaderBar3.vue'
import Visualizer from '@/components/apps-components/fluxity/Visualizer.vue'
import History from '@/components/apps-components/fluxity/History.vue'

import axios from "axios";

export default {
  name: 'Fluxity',
  components: {
    HeaderBar3,
    Visualizer,
    History
  },
  data(){
    return {
      site: null,
      service_mode: null, // PV | PB
      stage: null,        // D  | P
      customer: null,     // Solve
      loading: false,
      // View
      view: 'fluxity',
      hbref: 'hb_fluxity',
      section: null,
      preferred: 'visualizer',
      sections: [],
      apps: {},
      // Components keys.
      compkeys: {
        visualizer: 0,
        history: 0
      }
    }
  },
  methods:{
    solve(){
      this.loading = true
      const params = {view: this.view}
      const dest = this.site + '/suite/main/dnsuite'
      axios
          .get(dest, {params})
          .then(rx => {
            this.customer = rx.data.customer
            this.username = rx.data.username
            this.apps     = rx.data.apps
            this.sections = rx.data.sections
            this.$refs[this.hbref].init(this.view, this.username, this.customer, this.sections, this.apps)
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            //this.processErrorMessage(error)
          });
    },
    setSection_out(entry){
      this.section = entry
    }
  },
  created: function(){
    // localStorage.setItem('vrfaware_app','Alchemy')
    this.stage = process.env.NODE_ENV
    this.service_mode = process.env.VUE_APP_SERVICE_MODE
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    this.solve()
  }
}
</script>

<style scoped>
  .section-button{
    background-color: Black;
    border: solid 2px Black;
    color: White;
  }
  .section-button:hover{
    color: rgb(72,167,238);
    border-bottom: solid 2px rgb(162, 200, 250);
  }
</style>
